<template>
  <div></div>
</template>

<script>
import Vue from "vue";
import router from "@/router/router";
import {getLoginUser} from "@/utils/auth";
export default {
  components: {},
  data() {
    //hemiao10066
    return {
      num: 0,
      token:
          "25.798262a0408c649525e232fbe1dce9c6.315360000.1982650671.282335-28193057"
    };
  },
  computed: {},
  watch: {},
  created() {
    this.queryToken();
  },
  mounted() {
    // if (process.env.NODE_ENV === "production") {
    setInterval(this.msg, 50 * 1000); //10秒执行一次
    setInterval(this.msgs, 1000);
    setInterval(this.tcpsMsg, 300 * 1000);
    // }
  },
  methods: {
    async queryToken() {
      const { result } = await this.$store.dispatch("queryToken");
      this.token = result;
    },
    // play(tex) {
    //   const { storeCode } = getLoginUser();
    //   if (storeCode != "53010017032439") {
    //     setTimeout(() => {
    //       let preFixAudioUrl = "https://imgcdn.hemiao100.com/audio/dingdong.wav";
    //       let preFixAudio = new Audio(preFixAudioUrl);
    //       preFixAudio.src = preFixAudioUrl;
    //       preFixAudio.play();
    //     }, 0);
    //   }
    //   setTimeout(() => {
    //     let url = `http://tts.baidu.com/text2audio?lan=zh&ie=UTF-8&ctp=1&per=0&spd=5&cuid=9C-B6-D0-62-9F-89&tok=${
    //         this.token
    //     }&tex=${encodeURI(tex)}`;
    //     console.log("通知声音rul:", url);
    //     let audio = new Audio(url);
    //     audio.src = url;
    //     audio.muted = false;
    //     audio.play();
    //   }, 1000);
    // },
    play(tex) {
      const { storeCode } = getLoginUser();
      if (storeCode != "53010017032439") {
        setTimeout(() => {
          let preFixAudioUrl = "https://imgcdn.hemiao100.com/audio/dingdong.wav";
          let preFixAudio = new Audio(preFixAudioUrl);
          preFixAudio.src = preFixAudioUrl;
          preFixAudio.play();
        }, 0);
      }
      setTimeout(() => {
        const utterance = new SpeechSynthesisUtterance(tex);
        utterance.lang = 'zh-CN';
        utterance.pitch = 1;
        utterance.rate = 1;
        utterance.volume = 1;
        window.speechSynthesis.speak(utterance);
      }, 1000);
    },
    async msg() {
      if (Vue.prototype.$failure) {
        const { result } = await this.$store.dispatch("queryNewOrde");
        let text = "";
        let play = false;
        const { storeCode } = getLoginUser();
        if (result === "cityOrder") {
          if (storeCode === "53010017032439") {
            play = false;
            let preFixAudioUrl = "https://imgcdn.hemiao100.com/audio/cityOrder.mp4";
            let preFixAudio = new Audio(preFixAudioUrl);
            preFixAudio.src = preFixAudioUrl;
            preFixAudio.play();
          } else {
            play = true;
            text = "您有一个同城配送订单";
          }
        } else if (result === "yes") {
          play = true;
          text = "您有一个新的微店订单";
        }
        if (play) {
          const h = this.$createElement;
          this.play(text + ",请注意接单备货");

          if (this.num < 3) {
            let that = this;
            this.$notify.info({
              title: "新消息",
              message: h("p", null, [
                h("span", null, text),
                h(
                    "a",
                    {
                      style: "color: teal",
                      on: {
                        click: this.go
                      }
                    },
                    "请注意接单备货"
                )
              ]),
              position: "bottom-right",
              duration: 2000,
              onClose() {
                that.num--;
              }
            });
            this.num++;
          }
        }
      }
    },
    async msgs() {
      if (
          new Date().getMinutes() === 0 &&
          new Date().getSeconds() === 0 &&
          Vue.prototype.$failure
      ) {
        const { result } = await this.$store.dispatch("queryPayOrderNum");
        if (result) {
          let str = `您有${result}个订单待发货，请查看订单后台`;
          this.play(str);
          const h = this.$createElement;
          this.$notify.info({
            title: "新消息",
            message: h("p", null, [
              h("span", null, "您有"),
              h(
                  "a",
                  {
                    style: "color: teal"
                    // on: {
                    //   click: this.go
                    // }
                  },
                  `${result}`
              ),
              h("span", null, "个订单待发货，请查看订单后台")
            ]),
            position: "bottom-right",
            duration: 2000
          });
        }
      }
    },
    async tcpsMsg() {
      console.log( new Date().getMinutes())
      console.log(new Date().getSeconds())
      const { storeCode } = getLoginUser();
      if (storeCode === "53010017032439") {
        if (Vue.prototype.$failure) {
          console.log("进入3")
          const { result } = await this.$store.dispatch("queryTcpsOrderNum");
          if (result) {
            let str1 = `您有${result}个同城极速达订单待发货，请注意备货`;
            this.play(str1);
            const h = this.$createElement;
            this.$notify.info({
              title: "新消息",
              message: h("p", null, [
                h("span", null, "您有"),
                h(
                    "a",
                    {
                      style: "color: teal"
                      // on: {
                      //   click: this.go
                      // }
                    },
                    `${result}`
                ),
                h("span", null, "个同城极速达订单待发货，请注意接单备货")
              ]),
              position: "bottom-right",
              duration: 2000
            });
          }
        }
      }
    },
    go() {
      router.beforeEach(async (to, from, next) => {
        next(`/orderCenter/orderListNew`);
      });
    }
  }
};
</script>
<style lang="scss" scoped></style>
